import React, { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 w-full bg-white shadow-md z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex-shrink-0">
            <a href="#intro" className="text-2xl font-bold text-purple-800">
              Khair Spa
            </a>
          </div>
          
          <nav className="hidden md:block">
            <ul className="flex space-x-8">
              <li><a href="#intro" className="text-gray-700 hover:text-purple-800 transition-colors">Home</a></li>
              <li><a href="#about" className="text-gray-700 hover:text-purple-800 transition-colors">About</a></li>
              <li><a href="#works" className="text-gray-700 hover:text-purple-800 transition-colors">Services</a></li>
              <li><a href="#footer" className="text-gray-700 hover:text-purple-800 transition-colors">Contact</a></li>
            </ul>
          </nav>
          
          <button 
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
        
        {isMenuOpen && (
          <div className="md:hidden pb-4">
            <nav>
              <ul className="space-y-2">
                <li><a href="#intro" className="block py-2 text-gray-700 hover:text-purple-800 transition-colors" onClick={() => setIsMenuOpen(false)}>Home</a></li>
                <li><a href="#about" className="block py-2 text-gray-700 hover:text-purple-800 transition-colors" onClick={() => setIsMenuOpen(false)}>About</a></li>
                <li><a href="#works" className="block py-2 text-gray-700 hover:text-purple-800 transition-colors" onClick={() => setIsMenuOpen(false)}>Services</a></li>
                <li><a href="#footer" className="block py-2 text-gray-700 hover:text-purple-800 transition-colors" onClick={() => setIsMenuOpen(false)}>Contact</a></li>
              </ul>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;